import React from 'react';
import Home from "../../components/Home/Home";

const OrgsPage = () => {
  return <Home />;
};

export default OrgsPage;
